<template>
  <div id="recbuysti">
    <div class="nr">
      <CompMarquee />
      <div class="center">
        <div class="ctnr">
          <h3>
            {{ this.menu | transMenuName(this.menuType) }}記錄
            <router-link to="/mem/getsti" class="lqtz"></router-link>
          </h3>
          <table>
            <thead>
              <tr>
                <th>編號</th>
                <th>張數</th>
                <th>贈送</th>
                <th>時間</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!stickerOrderList.length">
                <td colspan="4" class="noData">無資料</td>
              </tr>
              <tr v-for="(item, index) in stickerOrderList" :key="index">
                <td>{{ item.single_number }}</td>
                <td>{{ item.quantity }}</td>
                <td v-if="Math.sign(item.quantity) !== -1">
                  {{ item.gift_currency | coinName }}
                  {{ item.gift_quantity }}
                </td>
                <td v-else />
                <td>{{ item.created_at }}</td>
              </tr>
            </tbody>
          </table>
          <CompPager
            v-if="pageData"
            @evtpagerchg="vodGetPage"
            :int-per-page="page.pagesize"
            :int-tol-cnt="pageData.allnums"
            :int-cur-page="page.currentPage"
            ref="pager"
          ></CompPager>
        </div>
      </div>
      <CompFoot/>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {
    CompMarquee: require("@/components/parts/Marquee").default,
    CompPager: require("@/components/parts/pager").default,
    CompFoot: require("@/components/parts/Foot").default,
  },
  computed: {
    ...mapState({
      stickerOrderList: (state) => state.stickers.stickerOrderList,
      pageData: (state) => state.app.pageData,
      menu: (state) => state.website.menu,
    }),
  },
  data() {
    const initPage = { pagesize: 10, currentPage: 1 };
    return {
      initPage,
      page: Object.assign({}, initPage),
      menuType: "gtrans",
    };
  },
  methods: {
    vodGetPage(page) {
      this.page.currentPage = page;
      this.getStickerOrder();
    },
    async getStickerOrder() {
      const data = {
        page: this.page.currentPage,
        pagesize: this.page.pagesize,
      };
      await this.$store.dispatch("stickers/getStickerOrder", data);
    },
  },
  async mounted() {
    await this.getStickerOrder();
  },
};
</script>
<style scoped>
@import "~@/assets/css/recbuysti.css";
</style>
